export default {"src":"/_next/static/media/buddy_loan.320383be.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};